export const SPECIAL_PRICE_FILTERS_INITIAL_STATE = {
  client_attribute: [],
  product: [],
  sales_unit: [],
  status: [],
  date_range: null,
  q: ''
}

export const SPECIAL_PRICE_DEFAULT_PER_PAGE = 25

export const SPECIAL_PRICE_EMPTY_SELECT_FILTER = {
  mode: 'all',
  values: []
}

export const SPECIAL_PRICE_FILTER_QUERY_KEYS = [
  'client_attribute',
  'product',
  'sales_unit',
  'status',
  'q'
]

export const SPECIAL_PRICE_DETAIL_TAB_VALUE = 'detail'

export const SPECIAL_PRICE_DETAIL_TABS = [
  {
    value: SPECIAL_PRICE_DETAIL_TAB_VALUE,
    label: 'Detalle',
    icon: 'info'
  }
]

export const SPECIAL_PRICE_SHOW_TITLE = 'Detalle: Precio especial'

export const SPECIAL_PRICE_SHOW_DETAIL_SECTION_TITLE = 'Detalles del precio especial:'

export const SPECIAL_PRICE_SHOW_SCALE_SECTION_TITLE = 'Escalas configuradas'

export const SPECIAL_PRICE_SHOW_SCALE_SECTION_DESCRIPTION =
  'Detalle de los rangos de cantidades y precio especial configurados.'

export const SPECIAL_PRICE_SHOW_NOT_FOUND_MESSAGE = 'No se encontró el precio especial.'

export const SPECIAL_PRICE_SHOW_FETCH_ERROR_MESSAGE =
  'No se pudo cargar el detalle del precio especial.'

export const SPECIAL_PRICE_SHOW_SUSPEND_ERROR_MESSAGE =
  'No se pudo suspender el precio especial.'

export const SPECIAL_PRICE_SHOW_SUSPEND_CONFIRMATION =
  '¿Desea continuar con la suspensión del precio especial?'

export const SPECIAL_PRICE_SHOW_DETAIL_LABELS = {
  code: 'Código',
  scope: 'Cliente o atributo(s)',
  dateRange: 'Rango de fechas efectivas',
  client: 'Cliente'
}

export const SPECIAL_PRICE_SHOW_ACTION_LABELS = {
  suspend: 'Suspender tarea',
  copy: 'Crear copia'
}

export const SPECIAL_PRICE_SHOW_SCALE_LABELS = {
  minSale: 'Minimo de venta',
  maxSale: 'Maximo de venta',
  offerPrice: 'Precio de oferta',
  separator: 'la venta es a',
  unlimited: 'Ilimitado'
}

export const SPECIAL_PRICE_INDEX_TABLE_COLUMNS = [
  { key: 'start_date', label: 'FECHA INICIAL', className: 'col-w-100' },
  { key: 'end_date', label: 'FECHA FINAL', className: 'col-w-100' },
  { key: 'external_db_ref', label: 'CÓDIGO', className: 'col-w-70' },
  { key: 'scope_label', label: 'CLIENTE / ATRIBUTO', className: 'col-w-260' },
  { key: 'product', label: 'PRODUCTO', className: 'col-w-260' },
  { key: 'sales_unit', label: 'UNIDAD DE VENTA', className: 'col-w-100' },
  {
    key: 'minimum_special_price',
    label: 'PRECIO ESPECIAL',
    className: 'col-w-100',
    headerClassName: 'special-price-table__align-right'
  },
  { key: 'status', label: 'ESTADO', className: 'col-w-50' }
]

export const SPECIAL_PRICE_DETAIL_PRODUCT_TABLE_COLUMNS = [
  { key: 'db_ref', label: 'CODIGO DE PRODUCTO' },
  { key: 'name', label: 'NOMBRE DE PRODUCTO' },
  { key: 'sales_unit', label: 'UNIDAD DE VENTA' },
  {
    key: 'base_price',
    label: 'PRECIO ACTUAL',
    headerClassName: 'special-price-table__align-left'
  }
]

export const SPECIAL_PRICE_ACTION_BUTTON_SX = {
  minWidth: 146,
  '& .MuiButton-startIcon': {
    marginRight: '8px'
  }
}

export const SPECIAL_PRICE_DANGER_ACTION_BUTTON_SX = {
  ...SPECIAL_PRICE_ACTION_BUTTON_SX,
  color: '#d94e4e',
  borderColor: '#d94e4e',
  backgroundColor: '#ffffff',
  '&:hover': {
    color: '#ffffff',
    borderColor: '#d94e4e',
    backgroundColor: '#d94e4e'
  }
}

export const SPECIAL_PRICE_SCALE_FIELD_SX = {
  '& .MuiOutlinedInput-root': {
    height: 40,
    borderRadius: '4px',
    backgroundColor: '#ffffff',
    '& fieldset': {
      borderColor: '#5e8dc9',
      borderWidth: '1px'
    },
    '&:hover fieldset': {
      borderColor: '#4a7dbd'
    },
    '&.Mui-focused fieldset': {
      borderColor: '#4a7dbd'
    },
    '&.Mui-disabled': {
      backgroundColor: '#f3f4f6'
    },
    '&.Mui-disabled fieldset': {
      borderColor: '#cfd5de'
    }
  },
  '& .MuiInputLabel-root': {
    color: '#4b4b6a',
    fontSize: '12px',
    transform: 'translate(12px, -7px) scale(1)',
    transformOrigin: 'top left'
  },
  '& .MuiInputLabel-root.Mui-focused, & .MuiInputLabel-root.MuiFormLabel-filled': {
    transform: 'translate(12px, -7px) scale(1)'
  },
  '& .MuiInputBase-input': {
    fontSize: '16px',
    color: '#3f3f56',
    paddingTop: '10px',
    paddingBottom: '10px'
  },
  '& .MuiInputBase-input.Mui-disabled': {
    WebkitTextFillColor: '#8b92a0'
  },
  '& .MuiInputAdornment-root': {
    color: '#3f3f56'
  },
  '& .MuiInputAdornment-root .MuiTypography-root': {
    color: 'inherit'
  },
  '& .MuiOutlinedInput-root.Mui-disabled .MuiInputAdornment-root': {
    color: '#8b92a0'
  },
  '& .MuiInputLabel-root.Mui-disabled': {
    color: '#7b8595'
  }
}
